import React, { useState } from 'react';
import moment from 'moment';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { Form as FinalForm } from 'react-final-form';
import { FormattedMessage } from '../../util/reactIntl';

import { createSlug } from '../../util/urlHelpers';
import { createResourceLocatorString } from '../../util/routes';

import { H2, FieldTextInput, Form, IconSpinner } from '../../components';

import css from './ListingPage.module.css';
import { FaStar } from 'react-icons/fa6';
import { FaRegStar } from 'react-icons/fa6';
import { FaRegStarHalfStroke } from 'react-icons/fa6';

const renderStars = avgRating => {
  const stars = [];
  const halfStar = avgRating % 1 !== 0;
  const fullStars = Math.floor(avgRating);
  const emptyStars = 5 - Math.ceil(avgRating);

  for (let i = 0; i < fullStars; i++) {
    stars.push(<FaStar key={i} />);
  }

  if (halfStar) {
    stars.push(<FaRegStarHalfStroke key={fullStars} />);
  }

  for (let i = 0; i < emptyStars; i++) {
    stars.push(<FaRegStar key={fullStars + halfStar + i} />);
  }

  return stars;
};

const SectionReviewsForProvider = props => {
  const [sendReply, setSendReply] = useState('');
  const {
    reviewsData,
    fetchReviewsError,
    author,
    sendReplyInProgress,
    sendReplySuccess,
    sendReplyError,
    onSendReply,
    authorDisplayName,
    history,
    routes,
  } = props;
  const { reviews = [] } = reviewsData;
  const allReviews = reviews.flatMap(r => {
    const { listingId, title } = r;
    const arr = r.reviews.map(rv => ({ ...rv, listingId, title }));
    return arr;
  });

  const currentUser = useSelector(state => state.user.currentUser);
  const isAuthor = currentUser?.id?.uuid === author?.id?.uuid;
  const formatAddress = (address = '') => {
    const arr = address.split(', ');
    if (arr.length <= 3) return address;
    const result = arr.slice(-2).join(', ');
    return result.trim();
  };

  return (
    <section className={`${css.sectionProviderReviews} ${css.sectionReviews}`}>
      {fetchReviewsError ? (
        <H2 className={css.errorText}>
          <FormattedMessage id="ListingPage.reviewsError" />
        </H2>
      ) : null}
      <div className={`${css.providerReviews} ${css.reviews}`}>
        {allReviews.length > 0
          ? allReviews.map(review => {
              const {
                reviewStars = 0,
                reviewContent,
                userLocation,
                userName,
                postDate,
                replyLocation,
                _id,
                reply,
                replyDate,
                listingId,
                title,
              } = review;

              // console.log(990909, {
              //   id: listingId,
              //   slug: createSlug(title),
              // });

              const showReplyBtn =
                !(sendReply === _id) &&
                isAuthor &&
                !sendReplyInProgress &&
                !reply &&
                !(sendReplySuccess === _id);

              return (
                <div className={css.review} key={_id}>
                  <div className={css.reviewStarsDiv}>
                    <div className={css.reviewStars}>{renderStars(reviewStars)}</div>
                    <span>{parseFloat(reviewStars).toFixed(1)}</span>
                    <p
                      onClick={() =>
                        history.push(
                          createResourceLocatorString('ListingPage', routes, {
                            id: listingId,
                            slug: createSlug(title),
                          })
                        )
                      }
                      className={css.reviewListingNamep}
                    >
                      {title}
                    </p>
                  </div>
                  <p className={css.reviewerInfo}>
                    {userName}, <span>{formatAddress(userLocation)}</span>
                  </p>
                  <p className={css.datep}>{moment(postDate).format('Do MMMM, YYYY')}</p>
                  <p className={css.reviewContent}>{reviewContent}</p>
                  {showReplyBtn && (
                    <button onClick={() => setSendReply(_id)} className={css.replyBtn}>
                      Reply
                    </button>
                  )}
                  {sendReplyInProgress === _id ? (
                    <span className={classNames(css.rplyInfoSpn, css.rplyLoad)}>
                      <IconSpinner />
                    </span>
                  ) : sendReplyError?.id === _id ? (
                    <span className={classNames(css.rplyInfoSpn, css.rplyErr)}>
                      Unable to post reply
                    </span>
                  ) : isAuthor && sendReply === _id && !reply && !sendReplySuccess ? (
                    <div className={css.replyDv}>
                      <FinalForm
                        onSubmit={values => {
                          onSendReply(listingId, _id, values.replyContent).then(res => {
                            document.getElementById(_id + 'reply').style.display = 'block';
                            document.getElementById(_id + 'replyContent').innerHTML =
                              values.replyContent;
                          });
                        }}
                        render={renderProps => {
                          const { form, handleSubmit } = renderProps;
                          return (
                            <Form onSubmit={handleSubmit}>
                              <FieldTextInput type="textarea" name="replyContent" />
                              <div className={css.replyBtndv}>
                                <button className={css.sendReply}>Send</button>
                                <button
                                  className={css.rplyClose}
                                  type="button"
                                  onClick={e => {
                                    setSendReply('');
                                    form.restart();
                                  }}
                                >
                                  Close
                                </button>
                              </div>
                            </Form>
                          );
                        }}
                      />
                    </div>
                  ) : null}
                  <div className={css.replyDv}>
                    <div
                      id={_id + 'reply'}
                      className={classNames(css.reply, { [css.noReply]: !reply })}
                    >
                      <p className={css.reviewerInfo}>
                        {authorDisplayName}, <span>{formatAddress(replyLocation)}</span>
                      </p>
                      <p className={css.datep}>{moment(replyDate).format('Do MMMM, YYYY')}</p>
                      <p id={_id + 'replyContent'}>{reply}</p>
                    </div>
                  </div>
                </div>
              );
            })
          : null}
      </div>
      {/* {totalReviews > 5 && (
        <button className={css.moreReviews} type="button">
          View more reviews {' >'}
        </button>
      )} */}
    </section>
  );
};

export default SectionReviewsForProvider;
